import { Tag } from "@carbon/react";
import { OverflowMenuVertical } from "@carbon/react/icons";

import { transactionStatus } from "../../enums";
import { formatAsCurrency } from "../../utils";

export const topUpsDisplayFormatter = (item) => {
  const statusIndicator =
    item.status === transactionStatus.failed
      ? { statusText: "failed", statusType: "red" }
      : item.status === transactionStatus.successful
      ? { statusText: "successful", statusType: "green" }
      : { statusText: "processing", statusType: "gray" };

  // console.log("Payments item: ", item);

  return {
    ...item,
    amount: (
      <strong>
        {item.currencySymbol} {formatAsCurrency(item.amount)}
      </strong>
    ),
    status: (
      <Tag className="transaction-status" type={statusIndicator.statusType}>
        <span>{statusIndicator.statusText}</span>
        <div
          style={{ backgroundColor: statusIndicator.statusType }}
          className="status-indicator"
        />
      </Tag>
    ),
    description: <strong>{item.description}</strong>,
    customer: item.customer.email,
    gateway: (
      <img
        src={`${process.env.PUBLIC_URL}/${item.gatewayLogoUrl}`}
        alt="gateway logo"
      />
    ),
    date: <span className="date--oneline">{item.date}</span>,
    more: <OverflowMenuVertical />,
  };
};
